import * as React from 'react';
import {useState,useEffect} from 'react';
import {Grid, TableContainer,Table,TableHead,TableRow,TableCell,TableBody, Typography, Chip} from "@material-ui/core"
import {Theme,makeStyles} from '@material-ui/core/styles';


const useStyles = makeStyles((theme:Theme) => ({
    table: {
        minWidth: 650,
    },
    topic:{
        color:"#606060",
        borderBottomColor:"white",
        backgroundColor:"white",
        height:"20px"
    },
    topicText:{
        fontSize:"14px",
        marginTop:"20px"
    },
    content:{
        borderColor:"white",
    },
    contentText:{
        fontSize:"14px",
        marginTop:"5px",
        marginBottom:"5px"
    }
}));

export function DataTable(props){
    const classes=useStyles()

    const [tableObjArray,setTableObjArray]=useState([])
    const [tableHeadData,setTableHeadData]=useState([])
    
    const filterTable=(testCase)=>{
        let dataArray=[]
        props.testSummaryData.deviceTestResult.map((device)=>{
            const deviceId=Object.keys(device)[0]
            const dataObj= device[deviceId][testCase]
            if(dataObj!==undefined){
                dataObj["0"]=deviceId
            }
            dataArray.push(dataObj)
            return dataArray
        })
        if(dataArray[0]!==undefined){
            setTableHeadData(Object.keys(dataArray[0]).sort())
            setTableObjArray(dataArray)
        }
    }

    useEffect(()=>{
        let dataArray=[]
        props.testSummaryData.deviceTestResult.map((device)=>{
            const deviceId=Object.keys(device)[0]
            const dataObj= device[deviceId][props.allMainTestCases[0]]
            if(dataObj!==undefined){
                dataObj["0"]=deviceId
            }
            dataArray.push(dataObj)
            return dataArray
        })
        if(dataArray[0]!==undefined){
            setTableHeadData(Object.keys(dataArray[0]).sort())
            setTableObjArray(dataArray)
        }

    },[props.testSummaryData])
    
    return(
        <div>
            <Grid container>
                <Grid item xs={12} md={12} style={{textAlign:"left"}}>
                    {
                        props.allMainTestCases.map((button, index)=>{
                            return(
                                <Chip key={index} 
                                    label={button} 
                                    style={{borderRadius:"4px",margin:"10px",backgroundColor:"rgba(9, 30, 66, 0.04)",color:"#606060"}} 
                                    onClick={()=>filterTable(button)} />
                            )
                        })
                    }
                </Grid>
            </Grid>
            <TableContainer>
                <Table className={classes.table} size="small" aria-label="a dense table">
                    <TableHead>
                    <TableRow>
                        {
                            tableHeadData.map((topic,i)=>{
                                return(
                                    <TableCell align="left" className={classes.topic} key={i}>
                                        <Typography className={classes.topicText}>{topic=="0"?"Device Id": topic}</Typography> 
                                    </TableCell>
                                )
                            })
                        }
                    </TableRow>
                    </TableHead>
                    <TableBody>
                    {tableObjArray.map((row,i) => (
                        <TableRow key={i} style={{backgroundColor:((i%2)===0 ||(i/2)===0)?"#ECEDEF":"white"}}>
                            {
                                tableHeadData.map((head,j)=>{
                                    return(
                                        <TableCell align="left" key={j+i} className={classes.content}>
                                            <Typography className={classes.contentText} 
                                                style={{color:row[head]==="SUCCESS"?"#22C674":row[head]==="FAILURE"?"#FA5246":"black"}}>
                                                    {row[head]}
                                            </Typography>
                                        </TableCell>
                                    )
                                })
                            }
                        </TableRow>
                    ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}